import { render, staticRenderFns } from "./CertificateBadge.vue?vue&type=template&id=f78ac8ca&scoped=true&"
import script from "./CertificateBadge.vue?vue&type=script&lang=js&"
export * from "./CertificateBadge.vue?vue&type=script&lang=js&"
import style0 from "./CertificateBadge.vue?vue&type=style&index=0&id=f78ac8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78ac8ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f78ac8ca')) {
      api.createRecord('f78ac8ca', component.options)
    } else {
      api.reload('f78ac8ca', component.options)
    }
    module.hot.accept("./CertificateBadge.vue?vue&type=template&id=f78ac8ca&scoped=true&", function () {
      api.rerender('f78ac8ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/CertificateBadge.vue"
export default component.exports